import { useMemo } from 'react';
import { useDatasourceConnections } from './datasource/useDatasourceConnections';
import { useWorkAreaConnections } from './workArea/useWorkAreaConnections';
/**
 * ConnectionApi for engaging with ProjectWise Connections.
 * Will return api for WebView Datasources or ProjectWiseWeb Connections,
 * depending on the contextId.
 * @param projectWiseConnectionsConfig Configuration for the connections.
 * @param projectWiseConnectionsConfig.buddiRegionCode Region code for BUDDI
 * @param projectWiseConnectionsConfig.contextId Context ID for work area connections
 * @param projectWiseConnectionsConfig.gprId Organization ID (only used for datasource connections)
 * @param projectWiseConnectionsConfig.userOrg User organization from OIDC profile (only used for datasource connections)
 * @param projectWiseConnectionsConfig.getOidcToken Async function to get OIDC token
 * @returns ConnectionApi
 */
export function useProjectWiseConnections({ buddiRegionCode, contextId, gprId, userOrg, getOidcToken }) {
    const datasourceApi = useDatasourceConnections({
        buddiRegionCode,
        gprId,
        userOrg,
        getOidcToken
    });
    const workAreaApi = useWorkAreaConnections({
        buddiRegionCode,
        contextId: contextId !== null && contextId !== void 0 ? contextId : '',
        getOidcToken
    });
    const connectionApi = useMemo(() => {
        if (contextId) {
            return workAreaApi;
        }
        return datasourceApi;
    }, [contextId, datasourceApi, workAreaApi]);
    return connectionApi;
}
